module.exports = __webpack_public_path__ + "static/media/reporting-mini-logo.dd8bbaf6.jpg";